import type { MissingEnrollmentData } from "../../pages/Dashboard";

export const getMissingEnrollmentTotals = (rotation: MissingEnrollmentData) => {
  let missingEnrollments = 0;
  let missingPreferences = 0;

  for (const s of rotation.sessions) {
    missingEnrollments += s.missingEnrollments.length;
    missingPreferences += s.missingPreferences.length;
  }

  return { missingEnrollments, missingPreferences };
};
